import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '@/api/common';
import type { Reservation } from '@/api/reservations';

type Variables = {
  startDatetime: string;
  endDatetime: string;
  cityIds?: string[];
};
type Response = Reservation[];

export const useCalendarReservations = createQuery<
  Response,
  Variables,
  AxiosError
>({
  queryKey: ['calendar/reservations'],
  fetcher: (variables: Variables) => {
    let params: Record<string, any> = {
      start_datetime: variables.startDatetime,
      end_datetime: variables.endDatetime,
    };

    if (variables?.cityIds) {
      params.city_ids = variables.cityIds;
    }

    return client
      .get(`v2/internal/partners/reservations/calendar`, {
        params: params,
      })
      .then((response) => {
        return response.data.data;
      });
  },
});
